<template>
  <div class="order-approval pt-2xl">
    <preloader v-if="!order"></preloader>
    <div v-else class="container__sm">
      <h3 class="mb-0">
        <span v-if="order.Order.Order_header">
          <strong v-text="order.Order.Order_header"></strong>
          <span> / </span>
        </span>
        <span
          v-if="order.Order.WO_ID"
          v-text="`Order No. ${order.Order.WO_ID}`"
        ></span>
      </h3>

      <div class="my-xl p-l bg-gray-2 clearfix">
        <h4 class="font-md pb-xl">
          <span>{{localize('surgical_plan_approval')}}</span>
          <a
            v-if="surgicalPlan"
            class="note ml-s"
            :href="`${serverAPI}mflow/OrderFileDownload/${surgicalPlan.FileID}`"
            target="_blank"
            >{{localize('view_surgical_plan')}}</a>
        </h4>

        <div v-if="order.Order.Cust_name" class="review-field">
          <span>{{localize('patient_identification')}}:</span>
          <span v-text="order.Order.Cust_name"></span>
        </div>
        <div v-if="order.Order.MSOFT_CASE_NO" class="review-field">
          <span>{{localize('msoft_case_no')}}:</span>
          <span v-text="order.Order.MSOFT_CASE_NO"></span>
        </div>
        <div v-if="order.Order.Order_date" class="review-field">
          <span>{{localize('order_creation_date')}}:</span>
          <span v-text="formatDate(order.Order.Order_date)"></span>
        </div>
        <div v-if="order.Order.Actual_implant_date" class="review-field">
          <span>{{localize('surgery_planned_date')}}:</span>
          <span v-text="formatDate(order.Order.Actual_implant_date)"></span>
        </div>
        <div class="check-group">
          <!-- <form-field
            class="flex"
            field-type="checkbox"
            label="I agree to the <a class='inline-block ml-xs' href='/docs/MGUIDE_terms-of-service.pdf' target='_blank'>terms of service</a>"
            v-model="terms.serviceAgree"
            external-label
          ></form-field> -->
          <form-field
            class="flex stretch"
            field-type="checkbox"
            v-bind:label="localize('i_confirm_attached_approve_plans')"
            v-model="confirmation"
            req
            external-label
          ></form-field>
        </div>
        <span v-if="dirty && !confirmation" class="err text-red-2 note"
          >* {{localize('please_check_the_confirmation_checkbox')}}</span
        >
        <button @click="approve" class="btn btn-primary right">
          <i class="fal fa-check-circle mr-xs"></i>
          <span>{{localize('approve')}}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      dirty: false,
      order: null,
      confirmation: false
    };
  },
  mounted() {
    this.initOrder();
  },
  methods: {
    ...mapActions(["initOrdersList","loadNotifications"]),
    formatDate(date) {
      return moment(date).format("D/M/YYYY");
    },
    initOrder() {
      let vm = this;
      let postURL = `${SERVER_API[ENV]}mflow/OrderMguide/${this.orderId}`;
      fetch(postURL, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        headers: {
            "pragma": "no-cache",
            "cache-control": "No-Store",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          t: this.userToken,
          u: this.userID
        }
      })
        .then(res => res.json())
        .then(res => {
          console.log("UPDATE ORDER >> ", res);
          if (typeof res === "string" && res.indexOf("Denied") > -1) {
            vm.$toasted.show("Wrong order.. sorry about that.", {
              position: "bottom-center",
              // iconPack: "fontawesome",
              type: "warning",
              theme: "bubble",
              icon: {
                name: "fal fa-exclamation-circle mr-xs"
              }
            });
            vm.$router.push("/");
          }
          console.log("set ORDER >> ", res.Order);

          vm.order = res.Order;
          // vm.setOrder(res.Order);
        })
        .catch(err => err);
    },
    approve() {
      let vm = this;
      this.dirty = true;
      if (this.confirmation) {
        let postURL = `${SERVER_API[ENV]}mflow/OrderChangeStatus?order_id=${this.orderId}&status_id=3`;
        return fetch(postURL, {
          method: "POST",
          headers: { t: this.userToken, u: this.userID }
        })
          .then(res => res.json())
          .then(response => {
            console.log("status changed >> ", response);
            if (response === "ok") {
              vm.$toasted.show("Order has been approved", {
                position: "top-center",
                // iconPack: "fontawesome",
                type: "success",
                theme: "bubble",
                icon: {
                  name: "fal fa-check-circle mr-xs"
                }
              });
              vm.initOrdersList();
              vm.loadNotifications();
              vm.$router.push("/");
            } else {
              vm.$toasted.show("Something went wrong.. please try again", {
                position: "bottom-center",
                // iconPack: "fontawesome",
                type: "warning",
                theme: "bubble",
                icon: {
                  name: "fal fa-exclamation-circle mr-xs"
                }
              });
            }
            // commit("SET_ORDERS_LIST", response);
          })
          .catch(err => err);
      }
      return false;
    }
  },
  computed: {
    ...mapGetters(["userToken", "userID"]),
    serverAPI() {
      return SERVER_API[ENV];
    },
    orderId() {
      return this.$route.params.orderId;
    },
    surgicalPlan() {
      let files = this.order.MediaFiles;
      if (files.length) {
        return _.find(files, { FileType: 9 });
      }
      return null;
    }
  }
};
</script>
<style lang="stylus">
.order-approval
  min-height 60vh
  background #fff

  ul li
    background gray_2
    p
      _flex(row, wrap, center, flex-start)
      i
        round(24)
        font-size 12px
        line-height 24px
        background gray_7
        text-align center
        color #fff
        marg('xs', right)
      strong
        marg('xs', right)
</style>
